import { render, staticRenderFns } from "./Affix.vue?vue&type=template&id=60d85d28&scoped=true"
import script from "./Affix.vue?vue&type=script&lang=js"
export * from "./Affix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d85d28",
  null
  
)

export default component.exports